var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconType,{tag:"component",attrs:{"type":_vm.iconName,"color":_vm.iconColor,"size":_vm.iconSize}})}
var staticRenderFns = []

export { render, staticRenderFns }